import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import IntegrationsPage from '@/pages/setup/IntegrationsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

const integrationsSearchSchema = z.object({
  oauth: z.enum(['success', 'error']).optional(),
  message: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/setup/integrations')({
  beforeLoad: () => requireSetupPageAccess('/setup/integrations'),
  component: IntegrationsPage,
  validateSearch: integrationsSearchSchema,
});
